import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './RestaurantsCarousel.css';
import React, { memo, useState } from 'react';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM, get, getDictionaryItem } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import RouterLink from '../atoms/RouterLink';
import { isNil } from '../../utils/IsNil';
import getListing from '../../utils/getListing';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { ReactComponent as ChevronLeft } from '../../resources/icons/IconChevronLeftLight.svg';
import { RestaurantsCard } from '../atoms/RestaurantsCard/RestaurantsCard';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import Loader from '../atoms/Loader/Loader';
var splitter = ';,;';
var RestaurantsCarousel = /*#__PURE__*/memo(function (_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isVdsite = _useState2[0],
    setIsVdsite = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    items = _useState4[0],
    setItems = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    isFirstLoad = _useState8[0],
    setIsFirstLoad = _useState8[1];
  var dictionary = get(fields, 'data.dictionary');
  var reviews = getDictionaryItem(dictionary, 'reviews') || "";
  var title = get(fields, 'data.datasource.title.jss.value') || "";
  var subTitle = get(fields, 'data.datasource.text.jss.value') || "";
  var overviewButtonText = get(fields, 'data.datasource.buttonText.jss.value') || get(fields, 'data.overviewButton.title.jss.value');
  var overviewButtonUrl = get(fields, 'data.overviewButton.link.jss.value.href') || "";
  var overviewButtonLinktype = get(fields, 'data.overviewButton.link.jss.value.linktype') || "";
  var types = "type:Restaurant";
  var algoliaIndexes = get(params, 'SearchIndex');
  var fieldNameItem = get(fields, "data.datasource.searchFilter.targetItem.fieldNameItem.item.fieldName.value");
  var tagsToDisplay = get(fields, 'data.datasource.searchFilter.targetItem.tagsToDisplay.values') || [];
  var queryParams = tagsToDisplay.length ? tagsToDisplay.map(function (value) {
    return get(value, 'title.value');
  }).join(splitter) : '';
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var carouselBackgroundColor = BackgroundColorHex ? BackgroundColorHex : "transparent";
  var navigationAnalyticsButtonClick = function navigationAnalyticsButtonClick(text) {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['NavigationAnalytics'], params), text);
  };
  var moreButtonClickAnalytics = function moreButtonClickAnalytics(textArray) {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ButtonClickAnalytics'], params), textArray);
  };
  var bannerAnalyticsClick = function bannerAnalyticsClick(text) {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['BannerClickAnalytics'], params), text);
  };
  var titleAnalyticsClick = function titleAnalyticsClick(text) {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['TitleClickAnalytics'], params), text);
  };
  var favoriteAnalyticsClick = function favoriteAnalyticsClick(textArray) {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['FavoriteClickAnalytics'], params), textArray);
  };
  var algoliaRequest = function algoliaRequest() {
    setLoading(true);
    var category = tagsToDisplay.map(function (value) {
      return "".concat(fieldNameItem, ": ").concat(value.title.value);
    });
    var itemFilters = {
      facetFilters: [types].concat(_toConsumableArray(category)),
      hitsPerPage: 8
    };
    getListing(algoliaIndexes, itemFilters).then(function (response) {
      setItems(response.hits);
      setLoading(false);
      setIsFirstLoad(false);
    }).catch(function (error) {
      console.log("error", error);
    });
  };
  React.useEffect(function () {
    algoliaRequest();
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  if (isNil(fields) || isNil(fields.data) || isNil(fields.data.datasource)) {
    console.info('RestaurantsCarousel component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [RestaurantsCarousel component is empty: please provide data source]");
    }
    return null;
  }
  var renderItems = function renderItems() {
    if (!items.length) {
      return [];
    }
    return items.map(function (item, index) {
      return /*#__PURE__*/React.createElement(RestaurantsCard, {
        key: index,
        item: item,
        params: params,
        reviews: reviews,
        rtl: rtl,
        analyticsCallback: {
          bannerAnalyticsClick: bannerAnalyticsClick,
          titleAnalyticsClick: titleAnalyticsClick,
          favoriteAnalyticsClick: favoriteAnalyticsClick
        },
        baseHrefLink: overviewButtonUrl.toLowerCase()
      });
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    style: {
      background: carouselBackgroundColor
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "subTitle"
  }, subTitle), /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref2) {
    var renderCarousel = _ref2.renderCarousel,
      renderPreviousButton = _ref2.renderPreviousButton,
      renderNextButton = _ref2.renderNextButton,
      renderDots = _ref2.renderDots;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "btn-group"
    }, renderPreviousButton(function () {
      navigationAnalyticsButtonClick("previous");
    }), renderNextButton(function () {
      navigationAnalyticsButtonClick("next");
    })), renderCarousel(renderItems(), {
      responsive: {
        extra: {
          breakpoint: {
            max: 10000,
            min: 1601
          },
          items: 4
        },
        desktop: {
          breakpoint: {
            max: 1600,
            min: 901
          },
          items: 3
        },
        tablet: {
          breakpoint: {
            max: 900,
            min: 701
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 700,
            min: 0
          },
          items: 1
        }
      },
      containerClass: "carouselContainer"
    }), (isFirstLoad || loading) && /*#__PURE__*/React.createElement(Loader, null), !isFirstLoad && !loading && !items.length ? /*#__PURE__*/React.createElement("p", {
      style: {
        fontSize: "36px",
        fontWeight: "600",
        marginBottom: "50px"
      }
    }, "no Restaurants available") : null, /*#__PURE__*/React.createElement("div", {
      className: "paginationDot"
    }, renderDots()), /*#__PURE__*/React.createElement("div", {
      className: "overviewButton",
      onClick: function onClick() {
        return moreButtonClickAnalytics([title, overviewButtonText]);
      }
    }, /*#__PURE__*/React.createElement(RouterLink, {
      className: "btn btn-primary overviewButtonLink",
      href: "".concat(overviewButtonUrl, "?").concat(fieldNameItem, "=").concat(queryParams),
      linktype: overviewButtonLinktype
    }, /*#__PURE__*/React.createElement("span", {
      className: "overviewButtonText"
    }, overviewButtonText), /*#__PURE__*/React.createElement(ChevronLeft, {
      className: "ctaChevron"
    }))));
  }));
});
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl,
    style = _ref3.style;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    style: style
  }, children);
};
var commonStyles = "cj61cpj";
var ltrStyles = "leysvja";
var rtlStyles = "r1u2mezf";
export default RestaurantsCarousel;